import React, { FC } from 'react';
import styled from 'styled-components';
import Typography from '../Typography';

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DetailGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export type SectionData = {
  label: any;
  value: any;
}

interface AppDetailsSectionProps {
  data: SectionData[];
}

const AppDetailsSection: FC<AppDetailsSectionProps> = (props) => {
  const { data } = props;

  return (
    <DetailsContainer>
      {data.map(({ label, value }, index) => (
        <DetailGroup key={index}>
          <Typography
            variant="labelLarge"
            color="var(--sys-color--on-surface-variant)"
          >
            {label}
          </Typography>
          <Typography
            variant="bodyMedium"
            color="var(--sys-color--on-surface-variant)"
          >
            {value}
          </Typography>
        </DetailGroup>
      ))}
    </DetailsContainer>
  );
};

export default AppDetailsSection;

